import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'deepFilter',
    pure: false,
    standalone: false
})

@Injectable({
  providedIn: 'root'
})
export class Ng2DeepSearchPipe implements PipeTransform {

  /**
   *
   * @param items List of items to filter
   * @param term  a string term to compare with every property of the list
   *
   */
  static filterInclude(items: Array<{ [key: string]: any }>, term: string, columnsToInclude: Array<string> = [])
    : Array<{ [key: string]: any }> {

    const toCompare = term.toLowerCase();

    function checkInside(item: any, termInput: string) {
      for (const property in item) {
        if (columnsToInclude.some(x => x === property)) {
          if (item[property] === null || item[property] === undefined) {
            continue;
          }
          if (typeof item[property] === 'object') {
            if (checkInside(item[property], termInput)) {
              return true;
            }
          }
          if (item[property].toString().toLowerCase().includes(toCompare)) {
            return true;
          }
        } else {
          continue;
        }
      }
      return false;
    }

    return items.filter((item) => {
      return checkInside(item, term);
    });
  }

  static filterExclude(items: Array<{ [key: string]: any }>, term: string, columnsToExclude: Array<string> = [])
    : Array<{ [key: string]: any }> {

    const toCompare = term.toLowerCase();

    function checkInside(item: any, termInput: string) {
      for (const property in item) {
        if (columnsToExclude.some(x => x === property)) {
          continue;
        } else {
          if (item[property] === null || item[property] === undefined) {
            continue;
          }
          if (typeof item[property] === 'object') {
            if (checkInside(item[property], termInput)) {
              return true;
            }
          }
          if (item[property].toString().toLowerCase().includes(toCompare)) {
            return true;
          }
        }
      }
      return false;
    }

    return items.filter((item) => {
      return checkInside(item, term);
    });
  }

  /**
   * @param items object from array
   * @param term term's search
   */
  transform(items: any, term: string, props?: Array<string>, isInclude: boolean = false): any {
    if (!term || !items) { return items; }

    return isInclude ? Ng2DeepSearchPipe.filterInclude(items, term, props) : Ng2DeepSearchPipe.filterExclude(items, term, props);
  }
}
